interface ProgressBarProps {
  progress: number;
}

const ProgressBar = ({ progress }: ProgressBarProps) => {
  return (
    <div class="lc-w-full lc-bg-[#D9D9D9] lc-h-[3px] lc-rounded-[40px] lc-flex-shrink-0">
      <div
        class="lc-bg-cfa-blue-500 lc-h-full lc-rounded-full lc-transition-all lc-duration-300 lc-ease-in-out"
        style={{ width: `${progress}%` }}
      />
    </div>
  );
};

export default ProgressBar;
